<template>

    <div class="tabbed-teaser-container">

        <section v-if="(showCategoriesFilterParam || showCategoriesFilterParam != false) && categoriesData.length" class="categories-filter-section" v-bind:class="{'isEmpty' : categoriesData.length === 0 && categoriesData.length === 0}">

            <div class="categories-filter-section-inner container-fluid">

                <h2 class="heading">
                    FINDE DEIN THEMA
                </h2>

                <section class="category-btn-listing clearfix">

                    <template v-for="(category, categoryIndex) in processedCategories" :key="category.id">
                        <a href="javascript:void(0)" @click='setCategoriesFilterParam(category.id)' class="btn btn-category btn-parent-category"
                           v-bind:class="[(category.acf && category.acf.category_color ? 'btn-'+category.acf.category_color.replace('#','') : ''), categoriesFilterParam.indexOf(category.id) > -1 ? 'active' : '' ]"
                           :style="[
                             category.acf && category.acf.category_color ?
                               {
                                 'border-color': category.acf.category_color,
                                 ...(activeCategories.includes(category.id)
                                   ? {'background-color': category.acf.category_color, 'color': 'white'}
                                   : {'color': category.acf.category_color})
                               }
                               : {}
                           ]">
                            <img class="cross-icon" src="/img/ic_close_l_ffffff.svg"><span v-html="category.name"></span>
                        </a>
                        <a href="javascript:void(0)"
                           @click='setCategoriesFilterParam(subCategory.id)'
                           v-for="(subCategory, subCategoryIndex) in category.children"
                           :key="`${category.id}-${subCategory.id}`" class="btn btn-category"
                           v-bind:class="[(category.acf && category.acf.category_color ? 'btn-'+category.acf.category_color.replace('#','') : ''), categoriesFilterParam.indexOf(subCategory.id) > -1 ? 'active' : '', categoriesFilterParamShowAll ? '' : 'd-none d-md-block']"
                           :style="[
                             category.acf && category.acf.category_color ?
                               {
                                 'border-color': category.acf.category_color,
                                 ...(activeCategories.includes(subCategory.id)
                                   ? {'background-color': category.acf.category_color, 'color': 'white'}
                                   : {'color': category.acf.category_color})
                               }
                               : {}
                           ]">
                            <img class="cross-icon" src="/img/ic_close_l_ffffff.svg">{{ subCategory.name }}
                        </a>
                    </template>

                </section>

                <a @click='resetCategoriesFilterParam()' v-if="categoriesFilterParam && categoriesFilterParam.length > 0" class="btn btn-category btn-reset-categories-filter-param">
                    <img class='cross-icon' src='/img/ic_close_l_ffffff.svg'>Auswahl zurücksetzen
                </a>

                <div class="expand-collapse-link-container d-block d-md-none">
                    <a class="expand-collapse-link" @click='showHideAllCategoriesFilterParam()'>
                        <img v-bind:src="$themeUrl + '/img/ic_'+(categoriesFilterParamShowAll ? 'minus' : 'plus')+'_sm_000000.svg'">
                        <span v-html="categoriesFilterParamShowAll ? 'weniger Themen anzeigen': 'mehr Themen laden'"></span>
                    </a>
                </div>

            </div>

        </section>

        <section v-if="showTeaser" class="tabbed-teaser container-fluid tabbed-teaser-pink-white isLoaded">

            <div
                class="tabbed-teaser-inner row row-eq-height"
                v-bind:class="{ 'tabbed-teaser-inner-blank' : !teaserHeading }">

                <h2 class="heading" v-if="teaserHeading">
                    {{ teaserHeading }}
                </h2>

                <div class="col col-12 text-right sort-btn-container">
                    <button class="btn btn-default btn-sort" v-bind:class="{ 'active' : activeTab == 'latest'}"  @click='setOrderBy("latest")'>Neueste</button><button class="btn btn-default btn-sort" v-bind:class="{ 'active' : activeTab == 'ratings_average'}" @click='setOrderBy("ratings_average")'>Beliebteste</button>
                </div>

                <div class="col col-12" v-show="activeTab == 'top'">
                    <teaser-wide
                        teaser-id="latestTeaser"
                        :teaser-filter-params="tabbedTeaserFilterParam.top"
                        :categories="categories"
                        :categories-filter-param="categoriesFilterParam"
                        :page-filter-param="page.top"
                        :order-by-param="'top'"
                        :all-posts-data="allPostsData"
                        @showLoadMore="onShowLoadMore"
                    ></teaser-wide>
                </div>

                <div class="col col-12" v-show="activeTab =='latest'" v-bind:class="'cl-'+page.latest">
                    <teaser-wide
                        teaser-id="latestTeaser"
                        :teaser-filter-params="tabbedTeaserFilterParam.latest"
                        :categories="categories"
                        :categories-filter-param="categoriesFilterParam"
                        :page-filter-param="page.latest"
                        :order-by-param="'latest'"
                        :all-posts-data="allPostsData"
                        @showLoadMore="onShowLoadMore"
                    ></teaser-wide>
                </div>

                <div class="col col-12" v-show="activeTab =='ratings_average'">
                    <teaser-wide
                        teaser-id="ratingsAverageTeaser"
                        :teaser-filter-params="tabbedTeaserFilterParam.ratings_average"
                        :categories="categories"
                        :categories-filter-param="categoriesFilterParam"
                        :all-posts-data="allPostsData"
                        :page-filter-param="page.ratings_average"
                        :order-by-param="'ratings_average'"
                        @showLoadMore="onShowLoadMore"
                    ></teaser-wide>
                </div>
            </div>

            <!-- Load More -->
            <load-more v-if="showLoadMoreButton.top > 0" v-show="activeTab == 'top'" @clicked="loadMore()"></load-more>
            <load-more v-if="showLoadMoreButton.latest > 0" v-show="activeTab == 'latest'" @clicked="loadMore()"></load-more>
            <load-more v-if="showLoadMoreButton.ratings_average > 0"  v-show="activeTab == 'ratings_average'" @clicked="loadMore()"></load-more>

        </section>
    </div>

</template>

<script>

    // console.log('Teaser');

    import TeaserWide from './TeaserWide.vue';
    import LoadMore from './LoadMore.vue';
    import wpApi from '../services/wpApi';
    import cssMediaQueryHelper from '../services/cssMediaQueryHelper';

    export default {
        props: {
            categoriesData: {
                default: () => [],
                type: Array,
            },
            allPostsData: {
                default: () => [],
                type: Array,
            },
            teaserFilterParams: {
                default: () => ({}),
                type: Object,
            },
            'teaserHeading' : {
                default : '',
                type : String,
            },
            'teaserId' : {
                default : '',
                type : String,
            },
            'categories' : {
                default : ()=>{
                    return [];
                },
                type : Array,
            },
            'categoriesFilterParam' : {
                default : ()=>{
                    return [];
                },
                type : Array,
            },
            'showCategoriesFilterParam' : {
                default : true,
                type : Boolean,
            }
        },
        created(){
            this.load();
        },
        components : {
            LoadMore,
            TeaserWide
        },
        data(){
            return {
                activeTab: 'latest', // Default to 'latest' since there's no TOP button
                showLoadMoreButton : {
                    'top' : 0,
                    'latest': 0,
                    'ratings_average' : 0
                },
                page: {
                    'top' : 1,
                    'latest' : 1,
                    'ratings_average' : 1
                },
                tabbedTeaserFilterParam : {
                    'top' : {},
                    'latest': {},
                    'ratings_average' : {}
                },
                showTeaser: false,
                categoriesFilterParamShowAll: false,
                activeCategories: [],
                categoriesDataLoaded: false,
                processedCategories: []
            };
        },
        watch: {
            categoriesData: {
                immediate: true,
                handler(newVal) {
                    if (newVal && newVal.length > 0 && !this.categoriesDataLoaded) {
                        console.log('TabbedTeaser watcher: Using categoriesData from PHP');
                        this.categoriesDataLoaded = true;
                        this.processCategories(newVal);
                    }
                }
            }
        },
        methods : {
            load() {

                this.teaserFilterParams['per_page'] = 6;
                for (var tab in this.tabbedTeaserFilterParam) {
                    this.page[tab] = 1; // Page numbers start at 1, not 0
                    this.showLoadMoreButton[tab] = 0;
                    this.tabbedTeaserFilterParam[tab] = Object.assign({},this.teaserFilterParams);
                }
                this.tabbedTeaserFilterParam['top']['filter[meta_key]'] = 'top';
                this.tabbedTeaserFilterParam['top']['filter[meta_value]'] = '1';
                this.tabbedTeaserFilterParam['top']['orderby'] = 'modified';

                this.tabbedTeaserFilterParam['ratings_average']['orderby'] = 'meta_value';
                //this.tabbedTeaserFilterParam['top']['meta_key'] = 'top';
                this.tabbedTeaserFilterParam['ratings_average']['meta_key'] = 'ratings_average';

                // If we already loaded categories from PHP via watcher, skip API loading
                if (this.categoriesDataLoaded) {
                    return;
                }

                // Check if categories data was passed via props from PHP (for immediate prop availability)
                if (this.categoriesData && this.categoriesData.length > 0) {
                    console.log('TabbedTeaser load(): Using categoriesData from PHP');
                    this.categoriesDataLoaded = true;
                    this.processCategories(this.categoriesData);
                    return;
                }

                // No categoriesData prop provided - cannot load
                console.error('TabbedTeaser: categoriesData prop is required but was not provided');
                this.showTeaser = true; // Show empty state
            },
            processCategories(categories) {
                console.log('TabbedTeaser processCategories called with:', categories.length, 'categories');

                if (Array.isArray(categories) === false || categories.length === 0) {
                    this.showTeaser = true;
                    return;
                }

                // Clear processedCategories to prevent duplicates
                this.processedCategories = [];

                categories.sort((cat1, cat2) => {
                    if("acf" in cat1 && "acf" in cat2 && "order" in cat1.acf && "order" in cat2.acf){
                        if (cat1.acf.order > cat2.acf.order) return 1;
                        if (cat2.acf.order > cat1.acf.order) return -1;
                    }
                    if (cat1.id > cat2.id) return 1;
                    return -1;
                } );

                categories.forEach(element => {

                    // Use children if already provided by PHP
                    const children = element.children || [];
                    element.children = children;

                    if (children.length > 0) {
                        // Children already loaded from PHP
                        this.processChildCategories(element, children);
                    }
                    // No API fallback - children MUST be provided by PHP via props
                });

                this.showTeaser = true;
            },
            processChildCategories(parentElement, childrenData) {

                if (Array.isArray(childrenData) === false || childrenData.length === 0) {
                    return;
                }

                // Children are already in parentElement.children (from PHP)
                // Just ensure ACF data exists for each child
                childrenData.forEach(childElement => {
                    childElement.acf = childElement.acf || {};
                });

                this.processedCategories.push(parentElement);
                console.log('processedCategories length:', this.processedCategories.length);
            },
            resetFilters(){
                let perPage = 6;
                this.activeTab = 'top';

                for (var tab in this.tabbedTeaserFilterParam) {
                    if(this.tabbedTeaserFilterParam[tab].hasOwnProperty('page')){
                        delete this.tabbedTeaserFilterParam[tab]['page'];
                    }
                    this.showLoadMoreButton[tab] = 0;
                    this.page[tab] = 0;
                    this.tabbedTeaserFilterParam[tab]['per_page'] = perPage;
                }
            },
            resetCategoriesFilterParam(){
                // Clear all selected categories
                this.categoriesFilterParam.splice(0, this.categoriesFilterParam.length);
                this.activeCategories = [];

                // Reset page numbers when filter changes
                for (var tab in this.page) {
                    this.page[tab] = 1;
                }
            },
            setCategoriesFilterParam(category){
                // Toggle category in filter array
                const key = this.categoriesFilterParam.indexOf(category);
                if (key > -1) {
                    this.categoriesFilterParam.splice(key, 1);
                }else {
                    this.categoriesFilterParam.push(category);
                }

                // Update active categories for styling
                this.activeCategories = [...this.categoriesFilterParam];

                // Reset page to 1 when filtering changes
                for (var tab in this.page) {
                    this.page[tab] = 1;
                }

                // Trigger re-render by updating a computed property or forcing update
                // The watcher on categoriesFilterParam in TeaserWide will handle the filtering
            },
            setOrderBy(activeTab){
                // Always switch to the clicked tab
                this.activeTab = activeTab;
            },
            loadMore(){
                // Increment page for the active tab to load more posts
                if (this.showLoadMoreButton[this.activeTab] == 2) {
                    this.page[this.activeTab]++;
                    console.log('TabbedTeaser loadMore(): Incrementing page to', this.page[this.activeTab], 'for tab', this.activeTab);
                }
            },
            onShowLoadMore (value) {
                for (var tab in this.tabbedTeaserFilterParam) {
                    if(value.orderby == tab){
                        this.showLoadMoreButton[tab] = value.show ? 2 : 0;
                    }
                }
            },
            showHideAllCategoriesFilterParam(){
                this.categoriesFilterParamShowAll = !this.categoriesFilterParamShowAll;
            }
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';
    .tabbed-teaser-container{
        .categories-filter-section {
            background-color: $color-nochvielvor-white;
            overflow: hidden;
            will-change: height;
            .categories-filter-section-inner {
                @media screen and (max-width: 767.98px) {
                    padding-left: 24px;
                    padding-right: 24px;
                }
                @media screen and (min-width: 768px) {
                    padding-left: 4.75rem;
                }
                @media screen and (min-width: 1200px) {
                    padding-left: 4.75rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    padding-left: 4.75rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    padding-left: 4.75rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    padding-left: 4.75rem * $factor-2400;
                }
                .heading {
                    height: 32px;
                    font-size: 27px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.2;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;
                    margin-bottom: 30px;
                    @media screen and (min-width: 768px) {
                        height: 42px;
                        font-size: 35px;
                        line-height: 1.29;
                        margin-bottom: 60px;
                    }
                }
                .category-btn-listing{
                    /*display: flex;*/
                    margin-bottom: 15px;
                    @media screen and (min-width: 768px) {
                        margin-bottom: 27px;
                    }
                    @media screen and (min-width: 1200px) {
                        //margin-right: 210px * $factor-1200;
                        margin-bottom: 27px * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        //margin-right: 210px * $factor-1440;
                        margin-bottom: 27px * $factor-1200;
                    }
                    @media screen and (min-width: 1920px) {
                        //margin-right: 210px * $factor-1920;
                        margin-bottom: 27px * $factor-1200;
                    }
                    @media screen and (min-width: 2400px) {
                        //margin-right: 210px * $factor-2400;
                        margin-bottom: 27px * $factor-1200;
                    }
                    &:empty,
                    &.isEmpty {
                        margin-top: 0;
                        margin-bottom: 0;
                    }
                    .btn-category{
                        opacity: 1;
                        transition: opacity 200ms;
                        @for $i from 1 through 40 {
                            &:nth-child(#{$i}) {
                                transition-delay: #{$i * 100}ms;
                            }
                        }
                        &:not(.active){
                            i.cross-icon{
                                display: none;
                            }
                        }
                    }
                }
                .btn-parent-category{
                    @media screen and (min-width: 768px) {
                        clear: left;
                    }
                }
                .btn-category {
                    float: left;
                    margin: 0 10px 10px 0;
                    padding-left: 1rem;
                    padding-right: 1rem;
                    @media screen and (min-width: 768px) {
                        padding-left: 1.1rem;
                        padding-right: 1.1rem;
                        margin: auto 14px 14px auto;
                    }
                    @media screen and (min-width: 1200px) {
                        //margin:0 0.7rem * $factor-1200 0.7rem * $factor-1200 0;
                        padding-left: 1.1rem * $factor-1200;
                        padding-right: 1.1rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        //margin: 0 .7rem * $factor-1440 0.7rem * $factor-1440 0;
                        padding-left: 1.1rem * $factor-1440;
                        padding-right: 1.1rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        //margin: 0 0.7rem * $factor-1920 0.7rem * $factor-1920 0;
                        padding-left: 1.1rem * $factor-1920;
                        padding-right: 1.1rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        //margin: 0 0.7rem * $factor-2400 0.7rem * $factor-2400 0;
                        padding-left: 1.1rem * $factor-2400;
                        padding-right: 1.1rem * $factor-2400;
                    }
                    border-color: $color-nochvielvor-black;
                    color: $color-nochvielvor-black;
                    font-weight: bold;
                    &.active{
                        background-color: $color-nochvielvor-black;
                        color: $color-nochvielvor-white;
                    }
                    text-transform: uppercase;
                    &.btn-hiv-im-alltag{
                        border-color: $color-nochvielvor-blue;
                        color: $color-nochvielvor-blue;
                        &.active{
                            background-color: $color-nochvielvor-blue;
                            color: $color-nochvielvor-white;
                        }
                    }
                    &.btn-zukunft-mit-hiv{
                        border-color: rgba(231, 62, 80, 0.8);
                        color: rgba(231, 62, 80, 0.8);
                        &.active{
                            background-color: rgba(231, 62, 80, 0.8);
                            color: $color-nochvielvor-white;
                        }
                    }
                    &.btn-hiv-im-dialog{
                        border-color: $color-nochvielvor-gray;
                        color: $color-nochvielvor-gray;
                        &.active{
                            background-color: $color-nochvielvor-gray;
                            color: $color-nochvielvor-white;
                        }
                    }
                    &.btn-reset-categories-filter-param{
                        background-color: $color-nochvielvor-pink;
                        color: $color-nochvielvor-white;
                        border-color: $color-nochvielvor-pink;
                        margin-bottom: 24px;
                        margin-right:auto;
                        width: 100%;
                        @media screen and (min-width: 768px) {
                            float:right;
                            width: auto;
                        }
                    }
                    .cross-icon{
                        margin-left: -10px;
                        margin-right: 10px;
                        @media screen and (min-width: 1200px) {
                            margin-left: -10px * $factor-1200;
                            margin-right: 10px * $factor-1200;
                        }
                        @media screen and (min-width: 1440px) {
                            margin-left: -10px * $factor-1440;
                            margin-right: 10px * $factor-1440;
                        }
                        @media screen and (min-width: 1920px) {
                            margin-left: -10px * $factor-1920;
                            margin-right: 10px * $factor-1920;
                        }
                        @media screen and (min-width: 2400px) {
                            margin-left: -10px * $factor-1920;
                            margin-right: 10px * $factor-1920;
                        }
                    }
                }
            }
        }
        .btn-sort{
            color:$color-nochvielvor-white;
            border:1px solid $color-nochvielvor-white;
            font-size: 16px;
            font-weight: bold;
            width: 50%;
            @media screen and (min-width: 768px) {
                width: auto;
            }
            &:hover{
                color:$color-nochvielvor-white;
            }
            &.active{
                color:$color-nochvielvor-pink;
                background:$color-nochvielvor-white;
            }
        }
        .tabbed-teaser {
            overflow: hidden;
            will-change: height;

            &.tabbed-teaser-black-white .tabbed-teaser-inner{
                background-color: $color-nochvielvor-black;
                .heading {
                    color: $color-nochvielvor-white;
                }
            }
            &.tabbed-teaser-pink-white .tabbed-teaser-inner{
                background-color: $color-nochvielvor-pink;
                .heading {
                    color: $color-nochvielvor-white;
                }
            }
            &.tabbed-teaser-white-pink .tabbed-teaser-inner{
                background-color: $color-nochvielvor-white;
                .heading {
                    color: $color-nochvielvor-pink;
                }
            }
            &.tabbed-teaser-transparent-pink .tabbed-teaser-inner{
                background-color: transparent;
                .heading {
                    color: $color-nochvielvor-pink;
                }
            }
            &.tabbed-teaser-transparent-white-pink .tabbed-teaser-inner{
                background-color: transparentize($color-nochvielvor-white, 0.1);
                .heading {
                    color: $color-nochvielvor-pink;
                }
            }
            a {
                &,
                &:hover {
                    text-decoration: none;
                }
            }
            .tabbed-teaser-inner {
                padding: 15px 9px 6px;
                @media screen and (min-width: 768px) {
                    padding: 30px 15px;
                }
            }
            .tabbed-teaser-inner-loading {
                padding: 2.5rem 1.5rem 4rem 1.5rem;
                @media screen and (min-width: 1200px) {
                    padding: 2.5rem * $factor-1200 1.5rem * $factor-1200 4rem * $factor-1200 1.5rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    padding: 2.5rem * $factor-1440 1.5rem * $factor-1440 4rem * $factor-1440 1.5rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    padding: 2.5rem * $factor-1920 1.5rem * $factor-1920 4rem * $factor-1920 1.5rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    padding: 2.5rem * $factor-2400 1.5rem * $factor-2400 4rem * $factor-2400 1.5rem * $factor-2400;
                }
                &.tabbed-teaser-inner-blank {
                    padding-top: 4rem;
                    @media screen and (min-width: 1200px) {
                        padding-top: 4rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        padding-top: 4rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        padding-top: 4rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        padding-top: 4rem * $factor-2400;
                    }
                }
            }
            .heading {
                margin: 0 0 1.5rem 0;
                color: $color-nochvielvor-black;
                font-size: 2.25rem;
                font-weight: bold;
                text-transform: uppercase;
                @media screen and (min-width: 1200px) {
                    margin: 0 0 1.5rem * $factor-1200 0;
                    font-size: 2.25rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin: 0 0 1.5rem * $factor-1440 0;
                    font-size: 2.25rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin: 0 0 1.5rem * $factor-1920 0;
                    font-size: 2.25rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin: 0 0 1.5rem * $factor-2400 0;
                    font-size: 2.25rem * $factor-2400;
                }
            }
        }
        .action-container {
            transition: transform 400ms;
            will-change: transform;
            .action {
                width: 3.25rem;
                height: 3.25rem;
                margin-left: 3.25rem;
                background-color: $color-nochvielvor-black;
                animation-duration: 800ms;
                animation-iteration-count: infinite;
                animation-timing-function: ease-in-out;
                transform: translate3d(-50%, 50%, 0) rotate(-45deg);
                transition: background-color 400ms, transform 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                will-change: background-color, transform;
                @media screen and (min-width: 1200px) {
                    width: 3.25rem * $factor-1200;
                    height: 3.25rem * $factor-1200;
                    margin-left: 3.25rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    width: 3.25rem * $factor-1440;
                    height: 3.25rem * $factor-1440;
                    margin-left: 3.25rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    width: 3.25rem * $factor-1920;
                    height: 3.25rem * $factor-1920;
                    margin-left: 3.25rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    width: 3.25rem * $factor-2400;
                    height: 3.25rem * $factor-2400;
                    margin-left: 3.25rem * $factor-2400;
                }
                @keyframes action-scale-pulse {
                    0% {
                        transform: translate3d(-50%, 50%, 0) rotate(-45deg) scale(1);
                    }
                    50% {
                        transform: translate3d(-50%, 50%, 0) rotate(-45deg) scale(1.1);
                    }
                    100% {
                        transform: translate3d(-50%, 50%, 0) rotate(-45deg) scale(1);
                    }
                }
                .action-icon {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 1.6rem;
                    height: 1.6rem;
                    background-image: url(/img/ic_plus_ffffff.svg);
                    background-position: 50% 50%;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    transform: translate3d(-50%, -50%, 0) rotate(45deg);
                    transition: transform 1200ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                    will-change: transform;
                    @media screen and (min-width: 1200px) {
                        width: 1.6rem * $factor-1200;
                        height: 1.6rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        width: 1.6rem * $factor-1440;
                        height: 1.6rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        width: 1.6rem * $factor-1920;
                        height: 1.6rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        width: 1.6rem * $factor-2400;
                        height: 1.6rem * $factor-2400;
                    }
                }
            }
        }

        .expand-collapse-link-container{
            text-align: center;
            margin-bottom: 24px;
            .expand-collapse-link{
                color: $color-nochvielvor-black;
                font-size: 12px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: center;
                img{
                    display: block;
                    margin: auto auto 10px;
                }
            }
        }

        .sort-btn-container{
            margin-bottom:24px;
            @media screen and (min-width: 768px) {
                margin-bottom:30px;
            }
        }
    }

</style>
